'use client';

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// components
import { PrimartyBtn as Submit } from '../../Buttons';

const Input = styled.input`
  border: 0;
  font-size: 0.9rem;
  width: 100px;
  padding: 11px;
  margin: 0 0 10px 0;
  color: var(--red);
  @media only screen and (min-width: 768px) {
    margin: 0 25px;
  }
  &:focus {
    outline-color: #000;
    outline: thin dotted;
  }
  ::placeholder {
    color: var(--darkGrey);
    font-size: 0.9rem;
  }
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

const LocationInput = ({ userInput, isLoading, clearValue }) => {
  const [active, setActive] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (clearValue) {
      setInputValue('');
    }
  }, [clearValue]);

  return (
    <InputContainer>
      <Input
        type="text"
        placeholder="Enter zip code"
        onKeyPress={(e) => e.key === 'Enter' && userInput(inputValue)}
        onChange={(e) => {
          setActive(e.target.value.length >= 4 || !isLoading);
          setInputValue(e.target.value);
        }}
        value={inputValue}
      />
      <Submit
        label="Submit"
        backgroundColor="#FF6969"
        textColor="#fff"
        clickEvent={() => {
          if (inputValue?.length >= 4) userInput(inputValue);
        }}
        active
      />
    </InputContainer>
  );
};

LocationInput.propTypes = {
  userInput: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  clearValue: PropTypes.bool.isRequired
};

export default LocationInput;
